module.exports = "/_next/static/images/Folder@3x-93dcd2edafa97029882edb4a5c8bdfae.png";